import RequestManager from "../../../requests/RequestManager";
import StandingTask from "../../../requests/tasks/sports/standingTask";
import Utils from "../../../utils/Utils";
import { viewRanking, viewStageGroup } from "../TablaDePosiciones/constants";
import { tranformGroupsResponse, transformTeams } from "../TablaDePosiciones/utils";
import logger from 'src/utils/logger/logger';

export const getStandings = async (leagueId, view, groupCode, acceptLanguage,  version) => {
    try{
        const standingsTask = new StandingTask(leagueId, view, groupCode, acceptLanguage, version);
        const standings = await RequestManager.addRequest(standingsTask);

        const response = {}

        response.groups = standings.data.filters.availableGroups.map(group => ({
            id: group,
            label: Utils.cutPlayerString(group, 1, undefined, '')
        }));

        response.headersTable = standings.data.columns.standings.map((col, idx) => ({
            ...col,
            label: idx !== 1
                ? Utils.cutPlayerString(col.label, 3, undefined, '')
                : Utils.cutPlayerString(col.label, 20, undefined, '')
        }))

        if(view === viewStageGroup) response.standingsData = tranformGroupsResponse(standings.data.groupStandings.groups)

        if(view === viewRanking) response.rankingData = transformTeams(standings.data.ranking.teams)

        return response
    }catch (error) {
        logger.error('Error getting standing:', error);
        return {
            groups: [],
            standingsData: [],
            rankingData: [],
            headersTable: []
        };
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getStandings.js